<template>
  <b-modal v-model="isShow" centered :title="title" hide-footer>
    <b-img v-if="src" style="width: 100%" :src="src" rounded />
  </b-modal>
</template>

<script>
  export default {
    name: 'ShowImage',
    components: {
      // UpdateAFS,
    },
    data() {
      return {
        isShow: false,
        title: 'Ảnh giải trình',
        src: '',
      }
    },

    methods: {
      show(src, title) {
        this.title = title
        this.src = src
        this.isShow = true
      },

      close() {
        this.isShow = false
      },
    },
  }
</script>

<style scoped></style>
